
import { makeRequest } from './data_utils';

const loadChart = (id) => {
    const endpoint = `chart/${id}`;
    return makeRequest(endpoint, 'GET');
};

const loadChartDrill = (id, value) => {
    const endpoint = `chart/drill/${id}`;
    const body = {
        value: value
    };
    return makeRequest(endpoint, 'POST', body);
};

export const dataCharts = {
    loadChart,
    loadChartDrill
};


